/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_SourcesInputs */



/**
* | output |
* | --- |
* | "Sources" |
*
* @param {Assistant_SourcesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_sources = /** @type {((inputs?: Assistant_SourcesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_SourcesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sources")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fonti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Источники")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fuentes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("来源")
	if (locale === "ja") return /** @type {LocalizedString} */ ("情報源")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सूत्रों का कहना है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fontes")
	return /** @type {LocalizedString} */ ("Sources")
});